import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { MpsUserService } from '../../mps/services/mps-user.service';
import { applicationRouteNames } from '../application-route-names';
import { RoleEnum } from '../enums/roles.enum';

/**
 * Redirect guard for the home route (T044 — "at login" case).
 *
 * When the active role is PAIE and the user navigates to home (e.g. after the
 * OAuth2 login redirect lands on /home, or when clicking the logo), this guard
 * redirects to payroll-export so PAIE users never land on a page they cannot
 * access. All other users pass through.
 *
 * This guard is intentionally scoped to the home route only, so it never fires
 * while the PayrollExportGuard (case b) is switching the active role and
 * returning true for the payroll-export navigation.
 */
export const PaieHomeRedirectGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const user = userService.getUser();

  if (user?.role?.code?.toUpperCase() === RoleEnum.PAIE) {
    return router.createUrlTree([applicationRouteNames.payrollExport]);
  }

  return true;
};
